import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/recovery/:code",
  action: async ({ pathname }) => {
    const code = pathname.groups.code;
    const c = await import("./views/recovery.vue");
    return h(c.default, { code });
  },
};

export default route;
